// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__1iMQw","errors":"Errors_errors__1tCBA"};